import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const USER_VERIFY = async (e) => {
  const res = await axios.post(BASE_URL + `/account/verify`, e);
  return res.data;
};
